"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecoveryMethodError = exports.AuthBadSchema = exports.PayloadError = exports.UnexpectedArgumentError = exports.AuthUnexpectError = exports.AuthUnauthorizedError = exports.AuthBadRequestError = exports.handleError = void 0;

var _yup = require("yup");

class AuthUnauthorizedError extends Error {}

exports.AuthUnauthorizedError = AuthUnauthorizedError;

class AuthBadRequestError extends Error {}

exports.AuthBadRequestError = AuthBadRequestError;

class AuthUnexpectError extends Error {}

exports.AuthUnexpectError = AuthUnexpectError;

class AuthBadSchema extends _yup.ValidationError {}

exports.AuthBadSchema = AuthBadSchema;

class UnexpectedArgumentError extends Error {}

exports.UnexpectedArgumentError = UnexpectedArgumentError;

class PayloadError extends Error {}

exports.PayloadError = PayloadError;

class RecoveryMethodError extends Error {}

exports.RecoveryMethodError = RecoveryMethodError;

const handleError = err => {
  const {
    response
  } = err;

  if (err instanceof _yup.ValidationError) {
    throw new AuthBadSchema(err);
  }

  if (err instanceof UnexpectedArgumentError) {
    throw new UnexpectedArgumentError(err);
  }

  switch (response === null || response === void 0 ? void 0 : response.status) {
    case 400:
      throw new AuthBadRequestError(err);

    case 401:
      throw new AuthUnauthorizedError(err);

    default:
      throw new AuthUnexpectError(err);
  }
};

exports.handleError = handleError;